/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserExport
 */
export interface UserExport {
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_state?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserExport
     */
    filter_not_in_user_group_ids?: Array<number>;
    /**
     * 
     * @type {object}
     * @memberof UserExport
     */
    filter_label_ids?: object;
    /**
     * 
     * @type {object}
     * @memberof UserExport
     */
    filter_user_ids?: object;
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_fulltext?: string;
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_role?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserExport
     */
    filter_department?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserExport
     */
    filter_job_title?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UserExport
     */
    filter_overdue_content?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_personal_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_note?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserExport
     */
    filter_supervisor_id?: Array<number>;
    /**
     * 
     * @type {object}
     * @memberof UserExport
     */
    filter_user_label_ids?: object;
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_last_activity_before?: string;
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_assigned_content_count?: string;
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_completed_content_count?: string;
    /**
     * 
     * @type {string}
     * @memberof UserExport
     */
    filter_overdue_content_count?: string;
    /**
     * 
     * @type {object}
     * @memberof UserExport
     */
    filter_organization_unit_ids?: object;
    /**
     * 
     * @type {boolean}
     * @memberof UserExport
     */
    filter_include_descendants?: boolean;
}

/**
 * Check if a given object implements the UserExport interface.
 */
export function instanceOfUserExport(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserExportFromJSON(json: any): UserExport {
    return UserExportFromJSONTyped(json, false);
}

export function UserExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserExport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filter_state': !exists(json, 'filter_state') ? undefined : json['filter_state'],
        'filter_not_in_user_group_ids': !exists(json, 'filter_not_in_user_group_ids') ? undefined : json['filter_not_in_user_group_ids'],
        'filter_label_ids': !exists(json, 'filter_label_ids') ? undefined : json['filter_label_ids'],
        'filter_user_ids': !exists(json, 'filter_user_ids') ? undefined : json['filter_user_ids'],
        'filter_fulltext': !exists(json, 'filter_fulltext') ? undefined : json['filter_fulltext'],
        'filter_role': !exists(json, 'filter_role') ? undefined : json['filter_role'],
        'filter_department': !exists(json, 'filter_department') ? undefined : json['filter_department'],
        'filter_job_title': !exists(json, 'filter_job_title') ? undefined : json['filter_job_title'],
        'filter_overdue_content': !exists(json, 'filter_overdue_content') ? undefined : json['filter_overdue_content'],
        'filter_name': !exists(json, 'filter_name') ? undefined : json['filter_name'],
        'filter_email': !exists(json, 'filter_email') ? undefined : json['filter_email'],
        'filter_personal_id': !exists(json, 'filter_personal_id') ? undefined : json['filter_personal_id'],
        'filter_note': !exists(json, 'filter_note') ? undefined : json['filter_note'],
        'filter_supervisor_id': !exists(json, 'filter_supervisor_id') ? undefined : json['filter_supervisor_id'],
        'filter_user_label_ids': !exists(json, 'filter_user_label_ids') ? undefined : json['filter_user_label_ids'],
        'filter_last_activity_before': !exists(json, 'filter_last_activity_before') ? undefined : json['filter_last_activity_before'],
        'filter_assigned_content_count': !exists(json, 'filter_assigned_content_count') ? undefined : json['filter_assigned_content_count'],
        'filter_completed_content_count': !exists(json, 'filter_completed_content_count') ? undefined : json['filter_completed_content_count'],
        'filter_overdue_content_count': !exists(json, 'filter_overdue_content_count') ? undefined : json['filter_overdue_content_count'],
        'filter_organization_unit_ids': !exists(json, 'filter_organization_unit_ids') ? undefined : json['filter_organization_unit_ids'],
        'filter_include_descendants': !exists(json, 'filter_include_descendants') ? undefined : json['filter_include_descendants'],
    };
}

export function UserExportToJSON(value?: UserExport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filter_state': value.filter_state,
        'filter_not_in_user_group_ids': value.filter_not_in_user_group_ids,
        'filter_label_ids': value.filter_label_ids,
        'filter_user_ids': value.filter_user_ids,
        'filter_fulltext': value.filter_fulltext,
        'filter_role': value.filter_role,
        'filter_department': value.filter_department,
        'filter_job_title': value.filter_job_title,
        'filter_overdue_content': value.filter_overdue_content,
        'filter_name': value.filter_name,
        'filter_email': value.filter_email,
        'filter_personal_id': value.filter_personal_id,
        'filter_note': value.filter_note,
        'filter_supervisor_id': value.filter_supervisor_id,
        'filter_user_label_ids': value.filter_user_label_ids,
        'filter_last_activity_before': value.filter_last_activity_before,
        'filter_assigned_content_count': value.filter_assigned_content_count,
        'filter_completed_content_count': value.filter_completed_content_count,
        'filter_overdue_content_count': value.filter_overdue_content_count,
        'filter_organization_unit_ids': value.filter_organization_unit_ids,
        'filter_include_descendants': value.filter_include_descendants,
    };
}

